import React from 'react';
import {
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import Page from '../../../components/Page';
import ProlongForm from './ProlongForm';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CertificateProlongPage = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Пролонгация полиса"
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
        >
          <ProlongForm />
        </Grid>
      </Container>
    </Page>
  );
};

export default CertificateProlongPage;
